import { isNil } from "lodash";

function retrieveVariable(name) {
    return isNil(process.env[name]) ? null : process.env[name];
}

export default class Config {
    static appHeader() {
        return {
            appHeaderTitleTruncateLength: parseInt(
                retrieveVariable("REACT_APP_HEADER_TEXT_TRUNCATION_LENGTH"),
                10
            )
        };
    }

    static test() {
        return {
            testNameTruncateLength: parseInt(
                retrieveVariable("REACT_APP_TEST_NAME_TRUNCATE_LENGTH"),
                10
            )
        };
    }

    static page() {
        return {
            pageNameTruncateLength: parseInt(
                retrieveVariable("REACT_APP_PAGE_NAME_TRUNCATE_LENGTH"),
                10
            )
        };
    }

    static features() {
        return {
            audienceExpectations:
                retrieveVariable(
                    "REACT_APP_ENABLE_AUDIENCE_EXPECTATIONS_FEATURE"
                ) === "true",
            newDrivers:
                retrieveVariable("REACT_APP_ENABLE_NEW_DRIVERS_FEATURE") ===
                "true"
        };
    }

    static general() {
        return {
            releaseEnv: retrieveVariable("RELEASE_ENV"),
            nodeEnv: retrieveVariable("NODE_ENV"),
            publicUrl: retrieveVariable("PUBLIC_URL"),
            enableComparePagesPaletteEditor: !!JSON.parse(
                retrieveVariable(
                    "REACT_APP_ENABLE_COMPARE_PAGES_PALETTE_EDITOR"
                )
            ),
            helloBaseUrl: retrieveVariable("REACT_APP_HELLO_BASE_URL"),
            betaHost: retrieveVariable("REACT_APP_BETA_HOST")
        };
    }
}



// WEBPACK FOOTER //
// ./src/config.js